import {useRegisterEvents, useSigma} from "@react-sigma/core";
import {useEffect} from "react";
import {NodeData} from "../../types/Types";
import {openGeneCards} from "../ExternalLinks";
import {useTheCellMapContext} from "../../contexts/TheCellMapContext";
import {createRightClickNodeHandler} from "../../utils/nodeMenu";
import {SigmaEventPayload} from "sigma/sigma";

const GraphEventsController = () => {
  const sigma = useSigma();
  const graph = sigma.getGraph();
  const registerEvents = useRegisterEvents();
  const {setNodeMenuState} = useTheCellMapContext();

  const preventDefault = (payload: SigmaEventPayload) => {
    payload.preventSigmaDefault();
    payload.event.original.preventDefault();
  }

  /**
   * Initialize common events for all networks.
   */
  useEffect(() => {
    registerEvents({
      doubleClickNode({node, preventSigmaDefault}) {
        preventSigmaDefault(); // Prevent zooming on double-click

        /* Node is added to the graph in GraphDataController as NodeData type with extra label and size properties. */
        const nodeData: NodeData = graph.getNodeAttributes(node) as NodeData;
        openGeneCards(nodeData.e);
      },
      rightClickNode: createRightClickNodeHandler(setNodeMenuState),
      rightClickStage: preventDefault,
      enterNode() {
        sigma.getCanvases().mouse.classList.add("mouse-pointer");
      },
      leaveNode() {
        sigma.getCanvases().mouse.classList.remove("mouse-pointer");
      },
    });
  }, [registerEvents, graph, sigma, setNodeMenuState]);

  return null;
};

export default GraphEventsController;
